<template>
  <!-- 
    Code By     : 陈伦刚
    CreateTime  : 2021-06-23 11:37:46
    Description : 个人中心-动态
  -->
  <div>
    <div class="page">
      <div class="select-page">
        <div
          class="item"
          :class="{ active: selectActive === 0 }"
          @click="selectClick(0)"
        >
          关注动态
        </div>
        <div
          class="item"
          :class="{ active: selectActive === 1 }"
          @click="selectClick(1)"
        >
          与我相关
        </div>
      </div>
      <div class="box" v-if="selectActive === 0">
        <div class="item" v-for="(item, i) in dataList" :key="item.id">
          <div class="flex">
            <el-avatar :size="50" :src="baseUrl + item.user.avatar">
              <img :src="VUE_APP_DEFAULTAVATAR" />
            </el-avatar>
            <div style="margin-left: 20px; width: 82.6%">
              <div class="nickname">
                <span @click="open(`/desktop/center/${item.user.account.id}`)">
                  {{ item.user.nickname }}
                </span>
                <span style="color: #b2b2b3; margin-left: 8px">
                  {{ type[item.type] || "发布作品" }}
                </span>
              </div>
              <div class="time">
                {{ $dayjs(item.createTime).format("YYYY.MM.DD hh:mm:ss") }}
              </div>
            </div>
            <div style="text-align: right">
              <el-button
                v-if="item.followed !== 2"
                :type="'info'"
                :icon="item.followed === 0 ? 'el-icon-plus' : 'el-icon-minus'"
                @click="follow(item.user.account.id, i)"
                size="small"
                style="
                  width: 100.34px;
                  background: #fff;
                  border: 1px solid #dcdcdc;
                  color: #999;
                "
                :style="{
                  border:
                    item.followed === 1
                      ? '1px solid #dcdcdc'
                      : '1px solid #ff464c',
                  color: item.followed === 1 ? '#dcdcdc' : '#ff464c',
                }"
                round
              >
                {{ item.followed === 0 ? "关注" : "取消关注" }}
              </el-button>
            </div>
          </div>
          <div class="flex" style="margin: 20px 30px 30px 70px">
            <div @click="openWorks(item.data, item.type)">
              <img
                v-if="item.data.screenshot"
                class="cover"
                :src="baseUrl + item.data.screenshot"
              />
              <img
                v-else
                class="cover"
                src="@/assets/images/default-cover.png"
              />
            </div>
            <div
              class="info"
              style="
                flex: 1;
                background: #f2f2f2;
                line-height: 30px;
                height: 192px;
                padding: 20px;
              "
            >
              <div style="font-size: 16px; font-weight: bold">
                {{ item.data.title }}
              </div>
              <div style="font-size: 12px; color: #999">
                {{
                  item.data.keyword ? item.data.keyword.replace("%26", ";") : ""
                }}
              </div>
            </div>
          </div>
        </div>
        <div class="loading-btn" v-if="showLoading">
          <i class="el-icon-loading" v-show="loading"></i>
          <span @click="loadMore">
            {{ loading ? "加载中" : "点击加载更多" }}
          </span>
        </div>
      </div>
      <div class="box" v-if="selectActive === 1">
        <div class="item" v-for="(item, i) in dataList" :key="item.id">
          <div class="flex">
            <el-avatar :size="50" :src="baseUrl + item.data.avatar">
              <img :src="VUE_APP_DEFAULTAVATAR" />
            </el-avatar>
            <div style="margin-left: 20px; width: 82.6%">
              <div class="nickname">
                <span @click="open(`/desktop/center/${item.data.userId}`)">
                  {{ item.data.nickname }}
                </span>
                <span style="color: #b2b2b3; margin-left: 8px">
                  {{ type[item.type] || "发布作品" }}
                </span>
              </div>
              <div class="time">
                {{ $dayjs(item.createTime).format("YYYY.MM.DD hh:mm:ss") }}
              </div>
            </div>
            <div style="text-align: right">
              <el-button
                v-if="item.followed !== 2"
                :type="'info'"
                :icon="item.followed === 0 ? 'el-icon-plus' : 'el-icon-minus'"
                @click="follow(item.user.account.id, i)"
                size="small"
                style="
                  width: 100.34px;
                  background: #fff;
                  border: 1px solid #dcdcdc;
                  color: #999;
                "
                :style="{
                  border:
                    item.followed === 1
                      ? '1px solid #dcdcdc'
                      : '1px solid #ff464c',
                  color: item.followed === 1 ? '#dcdcdc' : '#ff464c',
                }"
                round
              >
                {{ item.followed === 0 ? "关注" : "取消关注" }}
              </el-button>
            </div>
          </div>
          <div class="flex" style="margin: 20px 30px 30px 70px">
            <div @click="openWorks(item.data, item.type)">
              <img
                v-if="item.data.screenshot"
                class="cover"
                :src="baseUrl + item.data.screenshot"
              />
              <img
                v-else
                class="cover"
                src="@/assets/images/default-cover.png"
              />
            </div>
            <div
              class="info"
              style="
                flex: 1;
                background: #f2f2f2;
                line-height: 30px;
                height: 192px;
                padding: 20px;
              "
            >
              <div style="font-size: 16px; font-weight: bold">
                {{ item.data.title }}
              </div>
              <div style="font-size: 12px">
                {{
                  item.data.keyword ? item.data.keyword.replace("%26", ";") : ""
                }}
              </div>
            </div>
          </div>
        </div>
        <div class="loading-btn" v-if="showLoading">
          <i class="el-icon-loading" v-show="loading"></i>
          <span @click="loadMore">
            {{ loading ? "加载中" : "点击加载更多" }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { dynamicFocus, dynamicRelated, follow } from "@/api/personal";
export default {
  data() {
    return {
      id: "",
      baseUrl: process.env.VUE_APP_RESOURCES_URL,
      VUE_APP_DEFAULTAVATAR: process.env.VUE_APP_DEFAULTAVATAR,
      selectActive: 0,
      page: {
        pageIndex: 1,
        pageSize: 8,
        total: 1,
      },
      loading: false,
      showLoading: true,
      avatar: "",
      dataList: "",
      type: {
        works: "发布作品",
        follow: "关注了我",
        collect: "收藏了我的作品",
        comment: "评论了我的作品",
        reply: "回复了我的评论",
      },
    };
  },
  created() {
    this.id = Number(
      location.href.split("/")[location.href.split("/").length - 1]
    );
    this.selectClick(0);
  },
  methods: {
    open(url) {
      open(url);
    },
    openWorks(data, type) {
      const id = data.materialId || data.worksId;
      if (type === "works") {
        open(`/works/player/${data.worksId}`);
      } else if (type === "material") {
        open(
          `/desktop/gaia-material/detail/${data.materialId}?contentType=video`
        );
      }
    },
    /**
     * 切换页面
     */
    selectClick(i) {
      this.dataList = [];
      this.selectActive = i;
      this.showLoading = true;
      this.getList();
    },
    getList(pageIndex = 1) {
      if (this.selectActive === 0) {
        this.dynamicFocus(pageIndex);
      } else if (this.selectActive === 1) {
        this.dynamicRelated(pageIndex);
      }
    },
    loadMore() {
      this.getList(this.page.pageIndex + 1);
    },
    /**
     * 处理分页
     */
    flushPage(res) {
      this.page.pageIndex = res.page.pageIndex;
      this.page.pageSize = res.page.pageSize;
      this.page.total = res.page.total;
      if (res.page.pageIndex * res.page.pageSize >= res.page.total) {
        this.showLoading = false;
      }
      setTimeout(() => {
        this.$forceUpdate();
      }, 0);
    },
    /**
     * 关注 取消关注
     */
    follow(id, index) {
      follow(id)
        .then((res) => {
          this.$message.success("操作成功");
          if (this.dataList[index].followed === 1) {
            this.dataList[index].followed = 0;
          } else {
            this.dataList[index].followed = 1;
          }
          this.$forceUpdate();
          // this.selectClick(this.selectActive);
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("操作失败");
        });
    },
    dynamicFocus(pageIndex = 1) {
      this.loading = true;
      this.page.pageIndex = pageIndex;
      dynamicFocus(this.page)
        .then((res) => {
          if (res.page.pageIndex === 1) {
            this.dataList = res.personalDynamics.map((el) => {
              return {
                createTime: el.createTime,
                data: JSON.parse(el.data),
                followed: 1,
                id: el.id,
                type: el.type,
                user: el.user,
              };
            });
          } else {
            this.dataList = [
              ...this.dataList,
              ...res.personalDynamics.map((el) => {
                return {
                  createTime: el.createTime,
                  data: JSON.parse(el.data),
                  followed: el.followed,
                  id: el.id,
                  type: el.type,
                  user: el.user,
                };
              }),
            ];
          }
          this.flushPage(res);
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    dynamicRelated(pageIndex = 1) {
      this.loading = true;
      this.page.pageIndex = pageIndex;
      dynamicRelated(this.page)
        .then((res) => {
          if (res.page.pageIndex === 1) {
            this.dataList = res.dynamicsList.map((el) => {
              return {
                createTime: el.createTime,
                data: JSON.parse(el.data),
                followed: el.followed,
                id: el.id,
                type: el.type,
                user: el.user,
              };
            });
          } else {
            this.dataList = [
              ...this.dataList,
              ...res.dynamicsList.map((el) => {
                return {
                  createTime: el.createTime,
                  data: JSON.parse(el.data),
                  followed: el.followed,
                  id: el.id,
                  type: el.type,
                  user: el.user,
                };
              }),
            ];
          }
          this.flushPage(res);
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.select-page {
  display: inline-block;
  padding: 0 0 10px;
  .item {
    float: left;
    width: 100px;
    height: 30px;
    background: #fff;
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold;
    font-weight: 700;
    color: #666;
    line-height: 28px;
    text-align: center;
    user-select: none;
    cursor: pointer;
  }
  .item.active {
    background: linear-gradient(90deg, #ff5b67, #ff464c 100%, #ff464c 0);
    color: #fff;
  }
  .item:first-child {
    border-radius: 6px 0 0 6px;
  }
  .item:last-child {
    border-radius: 0 6px 6px 0;
  }
}
.loading-btn {
  margin: 20px 0 0;
  text-align: center;
  cursor: pointer;
}
.page {
  margin: -40px auto 0;
}
.box {
  padding: 40px 20px;
  border-radius: 8px;
  background: #ffffff;
  margin-bottom: 60px;
}
.flex {
  display: flex;
  align-items: center;
}
.nickname {
  margin-bottom: 4px;
  font-size: 14px;
  color: #7594b3;
  cursor: pointer;
}
.time {
  font-size: 12px;
  color: #bebebe;
}
.cover {
  width: 340px;
  height: 190px;
  cursor: pointer;
}
</style>